<template>
    <div class="row">
        <div class="col-12 px-3 pr-md-4 pl-0">
            <mu-carousel transition="fade" class="p-0 carousel-detail mb-3" hide-controls>
                <mu-carousel-item v-for="(item, index) in info_tour.images" :key="index">
                    <img :src="item" class="img-carousel" @click="openModal(item, index)" />
                </mu-carousel-item>
            </mu-carousel>
        </div>
        <div class="col-12 px-3 pr-md-4 pl-0">
            <div class="row">
                <div class="col-12 col-md-6 d-flex justify-content-center justify-content-md-start align-items-center mb-3 mb-md-0">
                    <span class="text-2">{{ info_tour[`name_${lang}`] }}</span>
                </div>
                <div class="col-12 col-md-6 d-flex justify-content-center justify-content-md-end align-items-center mb-3 mb-md-0">
                    <tour-rating :value="info_tour.review" />
                </div>
                <div id="button_more" class="col-12 mb-3">
                    <button class="btn btn-outline-primary" @click="showTour">
                        {{ $t('module_tours.button.meet_tour') }}
                    </button>
                </div>
                <div id="text_tour" class="col-12 col-lg-7 px-4 pr-md-4">
                    <div class="row">
                        <div class="col-12">
                            <span class="text-5">
                            ${{ info_tour.pricing.adult_base }} MXN
                            </span>
                            <span class="text-11 pl-5">-30%</span>
                        </div>
                        <div class="col-12">
                            <span class="text-6">${{ info_tour.pricing.adult_average }} MXN</span>
                        </div>
                        <div class="col-12 mt-3 text-6 pr-4" v-html="info_tour[`description_${lang}`]">
                        </div>
                        <div class="col-12 mt-3">
                            <span class="text-3">
                                {{ $t('module_tours.before_reservation') }}
                            </span>
                        </div>
                        <div class="col-12 mt-3 text-6 pr-4" v-html="info_tour[`restrictions_${lang}`]">
                        </div>
                    </div>
                </div>
                <div class="col-12 col-lg-5 d-flex justify-content-center justify-content-lg-end align-items-start px-4 pr-md-4 mb-5">
                    <div class="row pr-2">
                        <div class="col-12 border-gray">
                            <div class="row">
                                <div class="col-12 text-center mt-4">
                                    <span class="text-3">
                                        {{ $t('module_tours.reservation_now') }}
                                    </span>
                                </div>
                                <div class="col-12">
                                    <div class="row">
                                        <div class="col text-center mt-3">
                                            <div class="row">
                                                <div class="col-12">
                                                    <span class="text-4">
                                                        {{ $t('module_tours.passengers.adult') }}
                                                    </span>
                                                </div>
                                                <div class="col-12">
                                                    <span class="text-5">
                                                        ${{ info_tour.pricing.adult_base }} MXN
                                                    </span>
                                                </div>
                                                <div class="col-12">
                                                    <span class="text-10">
                                                        ${{ info_tour.pricing.adult_average }} MXN
                                                    </span>
                                                </div>
                                                <div class="col-12 mt-2">
                                                    <div class="input-group d-flex justify-content-center align-items-center"
                                                        style="max-height: 40px !important;">
                                                        <div class="input-group-prepend">
                                                            <button
                                                                @click="countingPass('adults', 'adult', '-')"
                                                                class="btn btn-outline-primary d-flex justify-content-center align-items-center size-input-pass"
                                                                type="button" style="">
                                                                <span style="font-size: 16px;">-</span>
                                                            </button>
                                                        </div>

                                                        <span
                                                            class="input-label d-flex justify-content-center align-items-center">
                                                            {{ info_tour.passengers.adults }}
                                                        </span>
                                                        <div class="input-group-append">
                                                            <button
                                                                @click="countingPass('adults', 'adult', '+')"
                                                                class="btn btn-outline-primary d-flex justify-content-center align-items-center size-input-pass"
                                                                type="button" style="">
                                                                <span style="font-size: 16px;">+</span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col text-center mt-3"
                                            v-if="show_child"
                                            >
                                            <div class="row">
                                                <div class="col-12">
                                                    <span class="text-4">
                                                        {{ $t('module_tours.passengers.child') }} ({{info_tour.restriction_age}})
                                                    </span>
                                                </div>
                                                <div class="col-12">
                                                    <span class="text-5">
                                                        ${{ info_tour.pricing.child_base }} MXN
                                                    </span>
                                                </div>
                                                <div class="col-12">
                                                    <span class="text-10">
                                                        ${{ info_tour.pricing.child_average }} MXN
                                                    </span>
                                                </div>
                                                <div class="col-12 mt-2">
                                                    <div class="input-group d-flex justify-content-center align-items-center"
                                                        style="max-height: 40px !important;">
                                                        <div class="input-group-prepend">
                                                            <button
                                                                @click="countingPass('children', 'child', '-')"
                                                                class="btn btn-outline-primary d-flex justify-content-center align-items-center size-input-pass"
                                                                type="button" style="">
                                                                <span style="font-size: 16px;">-</span>
                                                            </button>
                                                        </div>

                                                        <span
                                                            class="input-label d-flex justify-content-center align-items-center">
                                                            {{ info_tour.passengers.children }}
                                                        </span>
                                                        <div class="input-group-append">
                                                            <button
                                                                @click="countingPass('children', 'child', '+')"
                                                                class="btn btn-outline-primary d-flex justify-content-center align-items-center size-input-pass"
                                                                type="button" style="">
                                                                <span style="font-size: 16px;">+</span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 d-flex justify-content-center mt-3">
                                    <datepicker v-model="date_selected" @input="dateSelected(false)" @changedMonth="monthChange" format="dd-MM-yyyy" :language="es" :inline="true" :disabled-dates="date_disable" ></datepicker>
                                </div>
                                <div class="col-12 my-4" v-if="options_time.length > 0">
                                    <div class="form-group form-control-lg px-2">
                                        <span class="text-13">{{ $t('module_tours.time') }}</span>
                                        <v-select
                                            v-model="time_selected"
                                            :options="options_time_list"
                                            item-title="label"
                                            item-value="key"
                                            :searchable="false"
                                            :filterable="false"
                                            :clearable="false">
                                            <template>{{ $t('selects.alert.error.origins_not_found') }}</template>
                                        </v-select>
                                    </div>
                                </div>
                                <div class="col-12 my-4 px-4" v-if="info_tour.passengers.adults > 0">
                                    <div class="row">
                                        <div class="col-5 d-flex justify-content-start">
                                            <span class="text-left text-6">
                                                {{ info_tour.passengers.adults }}
                                                {{ $t('module_tours.passengers.adults') }} 
                                                <!-- ($ {{ info_tour.pricing.adult_average }}) -->
                                            </span>
                                        </div>
                                        <div class="col-7 d-flex justify-content-end">
                                            <span class="text-right text-6">
                                                {{ summary.adults| currencyAmount }} MXN
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <hr />
                                <div class="col-12 my-4 px-4" v-if="show_child && info_tour.passengers.children > 0">
                                    <div class="row">
                                        <div class="col-5 d-flex justify-content-start">
                                            <span class="text-left text-6">
                                                {{ info_tour.passengers.children }}
                                                {{ $t('module_tours.passengers.children') }} 
                                                <!-- ($ {{ info_tour.pricing.child_average }}) -->
                                            </span>
                                        </div>
                                        <div class="col-7 d-flex justify-content-end">
                                            <span class="text-right text-6">
                                                {{ summary.children | currencyAmount }} MXN
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <hr />
                                <div class="col-12 my-4 px-4" v-if="summary.tasa > 0">
                                    <div class="row">
                                        <div class="col-5 d-flex justify-content-start">
                                            <span class="text-left text-6">
                                                {{ $t('module_tours.tasa') }} 
                                            </span>
                                        </div>
                                        <div class="col-7 d-flex justify-content-end">
                                            <span class="text-right text-6">
                                                {{ summary.tasa| currencyAmount }} MXN
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <hr />
                                <div class="col-12 d-flex justify-content-center mt-4">
                                    <div class="row">
                                        <div class="col-3 d-flex justify-content-start">
                                            <span class="text-left text-7">Total</span>
                                        </div>
                                        <div class="col-9 d-flex justify-content-end">
                                            <span class="text-right text-7">
                                                {{ summary.total| currencyAmount }} MXN
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 mt-4 mb-5 px-4">
                                    <button class="button-detail text-center btn-lg btn-block" @click="sendCheck()">
                                        <span class="text-12">
                                            {{ $t('module_tours.button.reservation_now') }}
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div id="modal_slider" :class="['modal px-3 px-md-5', `${show_modal ? 'd-flex' : 'd-none'}`]"
            @click="closeModal('overlay')">
            <div class="row p-0">
                <div class="col-12 p-0 d-flex justify-content-center align-items-center">
                    <img :src="select_image" alt="" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _GlobalHelper from "@/store/helpers/global";
import Rating from "@/components/Tour/Rating";
import Datepicker from "vuejs-datepicker";
import { en, es } from "vuejs-datepicker/dist/locale";
import _VallartaAdventures from '@/store/helpers/tours/vallarta_adventures'

import { mapMutations, mapGetters, mapActions } from "vuex";
export default {
    name: "tours-detail",
    components: {
        "tour-rating": Rating,
        Datepicker: Datepicker,
    },
    data() {
        return {
            date_disable: {
                to: null,
                dates: []
            },
            summary:{
                adults: 0,
                children: 0,
                tasa: 0,
                total: 0,
            },
            id_tour: null,
            booking: null,
            info_tour: null,
            data_dates: null,
            date_selected: null,
            time_selected: '',
            show_modal: false,
            show_child: true,
            show_responsive : true,
            select_image: null,
            element_select: null,
            // languages
            es: es,
            en: en,
            options_time: [],
            options_time_list: [],
            option_select: null,
            message: []
        };
    },
    computed: {
        ...mapGetters({
            language: _GlobalHelper.getters.language,
        }),
        loading: {
            set(data) {
                this.set_loading(data);
            },
            get() {
                return this.loading;
            },
        },
        lang: {
            set() {

            },
            get() {
                return this.language
            }
        },
    },
    methods: {
        ...mapActions({
            checkDates: _VallartaAdventures.actions.check_dates,
        }),
        ...mapMutations({
            set_loading: _GlobalHelper.mutations.loading,
            setAlertSimple: _GlobalHelper.mutations.setAlertSimple,
            setAlertOptions: _GlobalHelper.mutations.setAlertOptions,
        }),
        countingPass(type_pass, pass, operative){
            if(operative == '-') {
                this.info_tour.passengers[`${type_pass}`] = this.info_tour.passengers[`${type_pass}`] -1
                if(this.info_tour.passengers[`${type_pass}`] < 0) {
                    this.info_tour.passengers[`${type_pass}`] = 0
                }
            }
            if(operative == '+') {
                this.info_tour.passengers[`${type_pass}`] = this.info_tour.passengers[`${type_pass}`] + 1
            }

            this.summary[`${type_pass}`] = this.$fixed(Number(this.info_tour.passengers[`${type_pass}`] * this.info_tour.pricing[`${pass}_average`]))
            this.summary.tasa =  this.$fixed((Number(this.summary.adults) + Number(this.summary.children)) * 0.10)
            this.summary.total =  Number(this.summary.adults) + Number(this.summary.children) + Number(this.summary.tasa)
        },
        async searchTour() {
            this.info_tour = this.$storage.getKey("tour-selected");
            this.info_tour.restriction_age =
                this.info_tour.restriction_age != "no_child"
                    ? this.info_tour.restriction_age.replace("-", " a ")
                    : this.info_tour.restriction_age;
            this.show_child = (this.info_tour.restriction_age != 'no_child') ? true : false

            this.booking = this.$storage.getKey("booking_data");

            this.date_disable.to = new Date(this.$datetime.now('mm/dd/yyyy 00:00:00'))
            
            if(this.info_tour.summary != undefined){
                this.summary = this.info_tour.summary
            }

            await this.consultDates(this.$datetime.now('mm/yy'), this.$datetime.now('yyyy-mm-dd 00:00:00').split(' ')[0])

            if(this.info_tour.reservation != undefined) {
                this.date_selected = new Date (this.info_tour.reservation.day+" 00:00:00")
                this.dateSelected(true)
            }
            else {
                this.loading = { show: false, message: null}
            }
            
        },
        async consultDates(date_consult, from_date){
            let last_day = false
            await this.checkDates({
                booking_code: this.booking.code,
                tour_id: this.id,
                date: date_consult
            }).then(({success, data, error}) => {
                if(!success && error == undefined) {
                    this.loading = { show: false }
                    this.setAlertSimple({
                        show: true,
                        title: 'Problemas al procesar la informacion',
                        message: 'No ha sido posible guardar el proceso'
                    })
                    return
                }
                if (!success && error.length >= 0) {
                    if(error.length == 0) {
                        this.message.push(`module_tours.alert.error.error_proccess_request`)
                    }

                    error.forEach((key, index) => {
                        if(key.code == 'database_error') {
                            if(key.detail != undefined){
                                this.message.push(`module_tours.alert.error.${key.code}.detail.${key.detail.transaction}`)
                            }
                            else {
                                this.message.push(`module_tours.alert.error.${key.code}.detail.title`)
                            }
                        } 
                        if(!['unexpected_reference_authorization', 'error_proccess_request', 'database_error'].includes(key.code)) {
                            this.message.push(`module_tours.alert.error.${key.code}`)
                        }
                    })

                    if(this.message.length == 0) {
                        this.message.push(`module_tours.alert.error.error_proccess_request`)
                    }

                    if(this.message.length > 0){
                        this.setAlertSimple({
                            show: true,
                            title: 'api.title_error',
                            message: this.message
                        })
                        this.loading = { show: false, message: null}
                    }
                    return

                }
                if(success && data != undefined) {
                    this.data_dates = data.dates
                    let string_dates = JSON.stringify(data.dates)
                    if(!(string_dates.includes(from_date))) {
                        this.date_disable.dates.push(new Date(from_date+" 00:00:00"))
                    }
                    let day = from_date
                    while(!last_day) {
                        let day_after_format = this.$datetime.dateFormater(this.$datetime.addDays(day+" 00:00:00", 1), 'yyyy-mm-dd')
                        let month_day = this.$datetime.dateFormater(day+" 00:00:00", 'mmmm')
                        let month_after = this.$datetime.dateFormater(day_after_format+" 00:00:00", 'mmmm')
                        
                        if(month_day == month_after) {
                            if(!(string_dates.includes(day_after_format))) {
                                this.date_disable.dates.push(new Date(day_after_format+" 00:00:00"))
                            }
                            else {
                                if(this.data_dates[`${day_after_format}`].lenght == 0) {
                                    this.date_disable.dates.push(new Date(day_after_format+" 00:00:00"))
                                }
                            }
                            day = day_after_format
                        }
                        else{
                            last_day = true
                        }
                    }

                    this.loading = { show: false, message: null }
                }
            })
        },
        dateSelected(refresh) {
            
            this.loading = { show: true, message: `<h5>${this.$i18n.t('loading.global')}</h5>`}
            this.time_selected = ""
            let string_day = this.$datetime.dateFormater(this.date_selected, 'yyyy-mm-dd')
            let option_hour = this.data_dates[`${string_day}`] != undefined ? this.data_dates[`${string_day}`] : []
            let position_time = 0
            let options_time_list_temp = [] 

            for (let [index, item] of Object.entries(option_hour)) {
                item.start_hour = this.$datetime.dateFormater("01-01-0000 "+item.start_hour+":00", 'HH:MM TT')
                if(refresh) {
                    if(this.info_tour.reservation.time == item.start_hour){
                        position_time = index
                    }
                }

                options_time_list_temp.push({...item,...{
                    label: item.start_hour,
                    key: index   
                }})
            }

            this.options_time_list = options_time_list_temp
            this.options_time = option_hour

            if(refresh){
                this.time_selected = this.options_time[position_time] != undefined ? this.options_time[position_time] : ''
            }

            this.loading = { show: false, message: null }
            
            
        },
        async monthChange(e){
            this.loading = { show: true, message: `<h5>${this.$i18n.t('loading.global')}</h5>`}
            this.time_selected = ""
            let new_month = this.$datetime.dateFormater(e, 'mm/yy')
            let new_date = this.$datetime.dateFormater(e, 'yyyy-mm-dd')
            await this.consultDates(new_month, new_date)
        },
        closeModal(type) {
            this.show_modal = false;
        },
        // Modal
        openModal(image = null, index) {
            this.show_modal = true;
            this.select_image = image;
            this.element_select = index;
        },
        sendCheck() {
            this.loading = { show: true, message: `<h5>${this.$i18n.t('loading.global')}</h5>`}
            this.message = []

            let num_adults = (this.$validator.hasValue(this.info_tour.passengers.adults) && this.$validator.isInt(this.info_tour.passengers.adults.toString(), 1)) ? this.info_tour.passengers.adults : 0

            let num_children = (this.$validator.hasValue(this.info_tour.passengers.children) && this.$validator.isInt(this.info_tour.passengers.children.toString(), 1)) ? this.info_tour.passengers.children : 0
            let select_day = (this.date_selected != null) ? (this.$validator.hasValue(this.date_selected) ? this.$datetime.dateFormater(this.date_selected, 'yyyy-mm-dd') : null) : null
            let select_time = (this.time_selected != null) ? (this.$validator.hasValue(this.time_selected) ? this.time_selected.start_hour : null) : null
            
            if(num_adults == null) {
                this.message.push('module_tours.alert.error.num_adults_invalid')
            }
            if(num_children == null) {
                this.message.push('module_tours.alert.error.num_children_invalid')
            }
            if(select_day == null) {
                this.message.push('module_tours.alert.error.day_invalid')
            }
            if(select_time == null) {
                this.message.push('module_tours.alert.error.time_invalid')
            }
            if(num_adults == 0 && num_children == 0){
                this.message.push('module_tours.alert.error.select_passengers')
            }
            if(num_adults != null && num_adults > this.time_selected.max_adult) {
                this.message.push('module_tours.alert.error.num_adult_exceeded')
            }

            if(num_children != null &&  num_children > this.time_selected.max_child) {
                this.message.push('module_tours.alert.error.num_children_exceeded')
            }

            if(num_adults != null && num_children != null && ((num_children+num_adults) > this.time_selected.max_tickets)) {
                this.message.push('module_tours.alert.error.passengers_exceeded')
            }

            if (this.message.length > 0) {
                this.loading = { show: false, message: null}
                this.setAlertSimple({
                    show: true,
                    title: 'api.title_error',
                    message: this.message
                })
                return
            }
            this.info_tour.summary = this.summary
            this.info_tour.reservation = {
                day: select_day,
                time: select_time
            }
            this.info_tour.passengers.total = this.info_tour.passengers.adults + this.info_tour.passengers.children

            this.$storage.setKey("tour-selected", this.info_tour);
            this.$router.push({
                name: "tours-checkout",
            });
        },
        showTour(){
            var show_text = document.getElementById('text_tour')
            if(this.show_responsive) {
                show_text.setAttribute("style", "display: flex;");
            }
            else {
                show_text.setAttribute("style", "display: none;");
            }

            this.show_responsive = !this.show_responsive
            
            
        },
        clearAlert() {
            this.setAlertOptions({
                show: false,
                title: null,
                message: null,
                type: null,
                continue: false,
                confirm_label: null,
                cancel_label: null
            })
        }
},
    async created() {
        this.loading = { show: true, message: `<h5>${this.$i18n.t('loading.global')}</h5>`}
        if (this.$route.params.name == null ||this.$route.params.name == undefined || this.$storage.getKey("tour-selected") == null) {
            this.$router.push({
                name: "tours-search",
            });
        }
        else
        {
            this.id = this.$route.params.name
            await this.searchTour();
        }
        
    },
    beforeRouteLeave(to, from, next) {
        if(['tours-search'].includes(to.name)){
            this.$storage.deleteKey('tour-selected')
            next()
            return
        }
        else{
            if(!['tours-checkout'].includes(to.name)) {
                this.setAlertOptions({
                    show: true,
                    title: 'module_tours.alert.error.title',
                    message: 'module_tours.alert.error.message',
                    cancel_label: this.$i18n.t('module_tours.alert.error.cancel'),
                    confirm_label: this.$i18n.t('module_tours.alert.error.confirm'),
                    leave: () => {
                        this.$storage.deleteKey('tour-selected')
                        this.$storage.deleteKey('booking_data')
                        this.clearAlert()
                        next()
                    },
                    accept: () => {
                        this.clearAlert()
                    }
                })
                next(false)
                return
            }
        }
        next()
    }
}
</script>

<style lang="scss">
#text_tour {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
}

#button_more {
    display: none;
}
.carousel-detail {
    width: 100%;
    height: 12.5rem;
}

.img-carousel {
    width: 100%;
    height: 12.5rem;
}

@media only screen and (min-width:600px){
    .carousel-detail {
        width: 100%;
        height: 18.75rem;
    }

    .img-carousel {
        width: 100%;
        height: 18.75rem;
    }
}

@media only screen and (min-width:767px){
    .carousel-detail {
        width: 100%;
        height: 21.8rem;
    }

    .img-carousel {
        width: 100%;
        height: 21.8rem;
    }
}

@media only screen and (min-width: 1024px){
    .carousel-detail {
        width: 100%;
        height: 34.3rem;
    }

    .img-carousel {
        width: 100%;
        height: 34.3rem;
    }
}

.mu-carousel-indicator-icon {
    width: 40px !important;
    height: 3px;
    border-radius: 0px;
}

.modal {
    justify-content: center;
    align-items: center;
    background-color: #000000bb;
    z-index: 9999;
}

.text-2 {
    font-family: "Roboto Condensed Bold" sans-serif;
    font-weight: 600;
    font-size: 30px !important;
    color: #003768;
    line-height: 25px !important;
    text-transform: uppercase;
    letter-spacing: 0px;
}

.text-3 {
    font-family: "Roboto Condensed Bold" sans-serif;
    font-weight: 500;
    font-size: 23px !important;
    color: #003768;
    line-height: 30px !important;
    letter-spacing: 0px;
}

.text-4 {
    font-family: "Roboto Condensed Bold" sans-serif;
    font-weight: bold;
    font-size: 22px !important;
    color: #003768;
    line-height: 25px !important;
    letter-spacing: 0px;
}

.text-5 {
    font-family: "Roboto Condensed";
    font-weight: normal;
    font-size: 20px !important;
    color: #003768;
    line-height: 25px !important;
    text-transform: uppercase;
    letter-spacing: 0px;
    text-decoration: line-through;
}

.text-6 {
    font-family: "Roboto Condensed" !important;
    font-weight: 300 !important;
    font-size: 20px !important;
    color: #003768 !important;
    line-height: 25px !important;
    letter-spacing: 0px !important; 
    text-align: justify;
    text-justify: inter-word;
    a {
        display: inline;
        color: #003768 !important;
        font-weight: 600 !important;
    }
}

.text-7 {
    font-family: "Roboto Condensed Bold" sans-serif;
    font-weight: 600;
    font-size: 25px !important;
    color: #003768;
    line-height: 30px !important;
    letter-spacing: 0px;
}

.text-10 {
    font-family: "Roboto Condensed Bold" sans-serif;
    font-weight: bold;
    font-size: 18px !important;
    color: #003768;
    line-height: 25px !important;
    letter-spacing: 0px;
    text-transform: uppercase;
}

.text-11 {
    font-family: "Roboto Condensed";
    font-weight: 300;
    font-size: 20px !important;
    color: #fdba00;
    line-height: 25px !important;
    text-transform: uppercase;
    letter-spacing: 0px;
}

.text-12 {
    font-family: "Verdana";
    font-weight: 300;
    font-size: 20px !important;
    color: #ffffff;
    line-height: 25px !important;
    letter-spacing: 0px;
}

.text-13 {
    font-family: "Roboto Condensed Bold" sans-serif;
    font-weight: bold;
    font-size: 18px !important;
    color: #003768;
    line-height: 20px !important;
}

.input-label {
    font-size: 18px !important;
    color: #000000;
    line-height: 20px !important;
    letter-spacing: 0px;
    border: 1px solid #003768;
    height: 38px;
    width: 50px;
}

.border-gray {
    border: 1px solid #c9c9c9;
}

element.style {
    position: static;
}

.vdp-datepicker__calendar {
    width: 270px !important;
    height: 325px;
}

.button-detail {
    background: #ff985e 0% 0% no-repeat padding-box;
    border: 1px solid #707070;
    height: 73px;
}

.form-control {
    border-radius: 4px !important;
}

.size-input-pass {
    max-width: 40px !important;
    max-height: 40px !important;
}
@media (min-width: 820px) {
    #text_tour{
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
    }
}
@media (max-width: 800px) {
    #text_tour{
        display: none;
        justify-content: flex-start;
        align-items: flex-start;
    }

    #button_more {
        display: flex;
    }
}
</style>